module.exports = __webpack_public_path__ + "img/persona-en.e169617f.png";